import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=8c9b3a2e&scoped=true"
import script from "./IconGroup.vue?vue&type=script&lang=js"
export * from "./IconGroup.vue?vue&type=script&lang=js"
import style0 from "./IconGroup.vue?vue&type=style&index=0&id=8c9b3a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b3a2e",
  null
  
)

export default component.exports